import { Component } from '@angular/core';

// Create a constants file
const DOMAIN_NAME = 'https://api.samgetlan.com';
const CAPTURE_ENDPOINT = `${DOMAIN_NAME}/capture`;
const ANALYZE_ENDPOINT = `${DOMAIN_NAME}/analyze`;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor() {
    this.isOnMobile = this.mobileCheck();
  }
  isOnMobile = false;
  randomNumberIcon: 0|1|2|3|4 = 0;
  streamId = '';
  imageFileName = '';
  loading = false;
  analyzeLoading = false;
  error = false;
  errorText = '';
  winner = false;
  unknownAnalysis = false;
  // TODO: Change into a type or enum
  gamePlayed = 'unknown';

  get knownGame(): boolean {
    return this.gamePlayed !== 'unknown';
  }

  get buttonText(): string {
    return `Get screenshot from twitch.tv/${this.streamId}`;
  }

  get imageSource(): string {
    return this.imageFileName
  }

  generateErrorText(streamId: string): string {
    return `There was a problem. Please make sure ${streamId} is currently streaming on twitch.tv and try again`
  }

  private mobileCheck = (): boolean => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||(window as any).opera);
    return check;
  };

  private handleError(): void {
    this.loading = false;
    this.analyzeLoading = false;
    this.errorText = this.generateErrorText(this.streamId);
    this.error = true;
  }

  private handleConnectionRefusedError(): void {
    this.loading = false;
    this.analyzeLoading = false;
    this.errorText = 'There was a problem. It\'s probably Sam\'s fault, please let him know';
    this.error = true;
  }

  handleButtonClick() {
    if (this.streamId) {
      this.loading = true;
      this.error = false;
      this.gamePlayed = 'unknown';
      this.winner = false;
      this.errorText = '';
      this.unknownAnalysis = false;
      fetch(`${CAPTURE_ENDPOINT}/${this.streamId}`)
        .then(data => data.json())
        .then(response => {
          if (response.name !== 'Error' && response.data) {
            this.imageFileName = response.data.uploadedFilePath;
            this.loading = false; 
            const imageFileName = this.imageFileName.split('/').pop()
            this.triggerAnalysis(imageFileName.substring(0, (imageFileName.length - 4)));
          } else if (response.message === 'connect ECONNREFUSED 34.71.123.206:1234') {
            this.handleConnectionRefusedError();
          } else {
            this.handleError();  
          }
        })
        .catch(error => {
          this.imageFileName = '';
          this.handleError();
        });
    }
  }

  triggerAnalysis = async (imageFileName: string) => {
    if (this.isOnMobile) {
      this.randomNumberIcon = Math.floor(Math.random() * Math.floor(3)) + 1 as 1|2|3|4;
    }
    this.analyzeLoading = true;
    try {
      const data = await fetch(`${ANALYZE_ENDPOINT}/${imageFileName}`);
      const response = await data.json();
      this.gamePlayed = response.game;
      this.winner = response.winner;
      this.analyzeLoading = false;
      this.unknownAnalysis = this.gamePlayed === 'unknown' && !this.winner;
    } catch (err) {
      this.handleError();
    }
  }
}
